module.exports = __webpack_public_path__ + "img/tork.bdd8ad5f.png";